import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { ThNavHeader } from './ThNavHeader';
import { ThNavFooter } from './ThNavFooter';
import ThUserMenu from './ThUserMenu';

import { getClientId } from './utils/analyticsclientIdUtils';
import { encryptData } from './utils/encryptionUtils';
import { API_URL } from './utils/constants'

export class ThUserProfileDelete extends Component {
    static displayName = ThUserProfileDelete.name;

    constructor(props) {
        super(props);
        this.state = {
            userData: null, // Initialize userData state to null
            userInfo: null,
            contactname: '',
            contactmobile: '',
            submitstatus: '',
            requireMsg01: '',
            requireMsg02: '',
            submitting: false // Add a state variable to track form submission status
        };
    }

    componentDidMount() {
        // Retrieve data from session storage
        const userDataFromStorage = sessionStorage.getItem('userData');

        // Parse the data if it exists and set it to the component state
        if (userDataFromStorage) {
            const parsedUserData = JSON.parse(userDataFromStorage);
            this.setState({ userData: parsedUserData }, () => {
                // After setting the state, make the API call if userData is available
                if (this.state.userData && this.state.userData.loyaltyMemberId) {
                    this.callApiWithUserId(this.state.userData.loyaltyMemberId);
                }
            });
        }

        {
            // Google analytic
            const documentPath = "Profile request delete"; // Gets the current URL path
            const clientId = getClientId(); // Use the getClientId function

            // Push data to the GTM dataLayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'pageview',
                page: documentPath,
                clientId: clientId,
            });
        }
    }

    async callApiWithUserId(userId) {
        // Add the wait cursor class to the body element
        //document.body.classList.add('wait-cursor');

        // Generate Unix timestamp
        const timestamp = Math.floor(Date.now() / 1000);

        // Prepare and encrypt the payload
        const payload = { UserId: userId, RefLang: 'th', Timestamp: timestamp };
        const encryptedPayload = encryptData(payload);

        const token = this.state.userData.token;
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ Data: encryptedPayload })
        };

        try {
            const response = await fetch(`${API_URL}/api/CrmMemberGetInfo`, requestOptions);
            const data = await response.json();
            if (data) {
                data.salutation = data.salutation == null ? "" : data.salutation;
                this.setState({ userInfo: data, salutation: data.salutation, firstname: data.firstName, lastname: data.lastName, firstnameth: data.firstNameTH, lastnameth: data.lastNameTH, mobilephone: data.mobilePhone });
            }
            else {
                console.error('Error data:');
            }
        } catch (error) {
            console.error('API call error :', error);
        } finally {
            //document.body.classList.remove('wait-cursor'); // Remove the wait cursor class
        }
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    handleSubmit = async e => {
        e.preventDefault();
        const { userInfo, contactname, contactmobile } = this.state;
        var errorChk = false;

        if (!contactname) {
            this.setState({
                requireMsg01: 'ระบุ ชื่อ นามสกุล'
            });
            errorChk = true;
        }

        if (!contactmobile) {
            this.setState({
                requireMsg02: 'ระบุ เบอร์โทรศัพท์'
            });
            errorChk = true;
        }

        if (errorChk) {
            return;
        }

        // Generate Unix timestamp
        const timestamp = Math.floor(Date.now() / 1000);

        // Prepare and encrypt the payload
        const payload = { LoyaltyMemberId: userInfo.loyaltyMemberId, Salutation: userInfo.salutation, FirstName: contactname, LastName: '', FirstNameTH: '', LastNameTH: '', MobilePhone: contactmobile, Email: userInfo.email, Source: 'Website', RefLang: 'th', Timestamp: timestamp };
        const encryptedPayload = encryptData(payload);

        // Prevent double-clicking by disabling the submit button and changing cursor to 'wait'
        this.setState({ submitting: true });

        // Add the wait cursor class to the body element
        //document.body.classList.add('wait-cursor');

        const token = this.state.userData.token;
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ Data: encryptedPayload })
        };

        try {
            const response = await fetch(`${API_URL}/api/CrmMemberRequestDetele`, requestOptions);
            const data = await response.json();

            if (data.responseCode === "OK") {
                window.location.replace("/thuserprofiledeletethx");
            }
            else {
                this.setState({ submitstatus: data.responseMessage });

                // Enable the submit button and change cursor back to 'auto' after form submission completes
                this.setState({ submitting: false });
            }
        } catch (error) {
            console.error('Error during api:', error);
            // Handle error appropriately, e.g., show an error message to the user

            // Enable the submit button and change cursor back to 'auto' after form submission completes
            this.setState({ submitting: false });
        } finally {            
            //document.body.classList.remove('wait-cursor'); // Remove the wait cursor class
        }
    };

    render() {
        const { userInfo, contactname, contactmobile, submitting, submitstatus, requireMsg01, requireMsg02 } = this.state;

    return (
        <>
            <ThNavHeader />

            {/* Render the user data */}
            {userInfo && (
                <main id="main">
                    <section id="profile_section" className="profileBanner keyboardFocus" aria-label="Profile" tabIndex={-1}>
                        <ThUserMenu />
                    </section>
                    <section className="section-dashboard overflow-hidden pb-5">
                        <div className="container mt-4">
                            <div className="row mb-5 px-2">
                                <div className="col-md-12">
                                    <h3 className="fw-semibold mt-4">คำร้องขอใช้สิทธิของเจ้าของข้อมูลส่วนบุคคล</h3>
                                    <form className="form-sr" onSubmit={this.handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-4 mt-4 mb-3">
                                                <label className="form-label">ชื่อ นามสกุล</label>
                                                <input type="text" className="form-control" name="contactname" value={contactname} onChange={this.handleChange} />
                                                <div className="text-alert-2 mt-2">
                                                    {requireMsg01}
                                                </div>
                                            </div>                                            
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-3">
                                                <label className="form-label">เบอร์โทรศัพท์</label>
                                                <input type="text" className="form-control" name="contactmobile" value={contactmobile} onChange={this.handleChange} />
                                                <div className="text-alert-2 mt-2">
                                                    {requireMsg02}
                                                </div>
                                            </div>                                            
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-3">
                                                <label className="form-label">บัญชีสมาชิกที่ต้องการยกเลิก</label>
                                                <input type="text" className="form-control" defaultValue={userInfo.email} disabled />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 mt-4 mb-3">
                                                <p><strong>สิทธิของเจ้าของข้อมูลที่ประสงค์จะใช้ </strong></p>
                                                <p><strong>สิทธิขอให้ลบบัญชีสมาชิก Starbucks&reg; Reward และข้อมูลส่วนบุคคล :</strong> ท่านมีสิทธิขอให้เราลบบัญชีสมาชิก Starbucks&reg; Reward และข้อมูลส่วนบุคคลของท่านเท่าที่กฏหมายอนุญาตให้กระทำได้ แต่ทั้งนี้สิทธิดังกล่าวมิได้ครอบคลุมถึงการขอให้ลบข้อมูลส่วนบุคคลของท่านทั้งหมด เราจะพิจารณาคำขออย่างละเอียดเพื่อให้เป็นไปตามข้อกำหนดของกฏหมายที่เกี่ยวกับการประมวลผลข้อมูลส่วนบุคคลของท่าน </p>
                                                <p className="mt-4"><strong>ข้อสงวนสิทธิของบริษัทฯ </strong></p>
                                                <p>บริษัทฯ ขอแจ้งให้ผู้ยื่นคำร้องทราบว่า หากเกิดกรณีดังต่อไปนี้ บริษัทฯ อาจจำเป็นต้องปฏิเสธคำร้องขอของผู้ยื่นคำร้องเพื่อให้เป็นไปตามกฏหมายที่เกี่ยวข้อง: <br />
                                                    (1) ผู้ยื่นคำร้องไม่สามารถแสดงให้เห็นอย่างชัดเจนได้ว่าผู้ยื่นคำร้องเป็นเจ้าของข้อมูลหรือมีอำนาจในการยื่นคำร้องขอดังกล่าว <br />
                                                    (2) คำร้องขอดังกล่าวไม่สมเหตุสมผล เช่น กรณีไม่มีข้อมูลส่วนบุคคลนั้นอยู่ที่บริษัทฯ หรือเจ้าของข้อมูลไม่มีสิทธิตามที่ร้องขอ เป็นต้น <br />
                                                    (3) คำร้องขอดังกล่าวเป็นคำร้องขอฟุ่มเฟือย เช่น เป็นคำร้องขอที่มีลักษณะเดียวกัน หรือ มีเนื้อหาเดียวกันซ้ำซ้อนกันโดยไม่มีเหตุอันสมควร <br />
                                                    (4) บริษัทฯ มีเหตุผลอันสมควรตามกฏหมายที่จะปฏิเสธคำร้องขอของเจ้าของข้อมูล โดยเจ้าของข้อมูลสามารถศึกษารายละเอียดดังกล่าวได้ในหัวข้อ [“สิทธิของท่าน”] ในเอกสารการแจ้งข้อมูลการประมวลผลข้อมูลส่วนบุคคล (Privacy Notive) ซึ่งปรากฏที่เว็ปไซต์ของบริษัทฯ คลิกที่นี่ หรือ ดาวน์โหลดจาก QR Code ด้านล่างนี้</p>
                                                <p className="text-center"><img src="../media/rewards/qr-code-en.png" alt="QR Code" className="img-fluid" /></p>
                                                <p>(5) ในกรณีที่ท่านยื่นคําร้องขอใช้สิทธิลบบัญชีสมาชิกและข้อมูลส่วนบุคคล หากบัญชีสมาชิกของท่าน ยังคงมีมูลค่าเงินอยู่ บริษัทฯจะทําการโอนเงินคืนให้แก่ท่านเฉพาะในกรณีที่มูลค่าเงินในบัญชีสมาชิก ของท่านมีเพียงพอชําระค่าธรรมเนียมการโอนที่คิดโดยธนาคารผู้ให้บริการเท่านั้น <br />
                                                    ทั้งนี้ โดยปกติบริษัทฯ จะไม่คิดค่าใช้จ่ายในการดําเนินการตามคําร้องขอใช้สิทธิของเจ้าของข้อมูล อย่างไรก็ดี หากปรากฏอย่างชัดเจนว่าคําร้องขอดังกล่าวเป็นคําร้องขอที่ไม่สมเหตุสมผล หรือ คําร้อง ขอที่ซ้ําซ้อนเกินสมควร บริษัทฯ อาจคิดค่าใช้จ่ายในการดําเนินการตามสมควร เมื่อพิจารณาเหตุผลในการร้องขอตามสิทธิของเจ้าของข้อมูลเรียบร้อยแล้ว พิจารณาให้ผู้ยื่นคําร้องและเจ้าของข้อมูลทราบและดําเนินการที่เกี่ยวข้องภายใน บริษัทฯ จะแจ้งผลในการ 30 วันนับแต่วันที่ได้รับ <br />
                                                    คําร้องขอ อย่างไรก็ตาม ในบางกรณีอาจใช้เวลามากกว่า 30 วัน หากคําขอของผู้ยื่นคําร้องมีความ ซับซ้อน หรือมีการยื่นคําขอหลายคําขอ โดยในกรณีเช่นนี้ บริษัทฯ จะแจ้งผู้ยื่นคําร้องและคอยรายงาน ความคืบหน้าให้ทราบ</p>
                                                <p className="mt-4"><strong>การรับทราบและยินยอม </strong></p>
                                                <p>ข้อมูลส่วนบุคคลของเจ้าของข้อมูลที่บริษัทฯ เก็บรวบรวมได้จากคําร้องขอใช้สิทธิของเจ้าของข้อมูล ฉบับนี้ จะถูกนําไปใช้เพื่อดําเนินการตามคําร้องขอใช้สิทธิของเจ้าของข้อมูลส่วนบุคคลตามที่กําหนดไว้ใน พระราชบัญญัติ คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (“พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล”) เท่านั้น โดยข้อมูลในคําร้องขอใช้สิทธิฉบับนี้ อาจถูกเปิดเผยไปยังบริษัทย่อย หรือบริษัทในเครือของบริษัทฯ เท่าที่จําเป็นเพื่อวัตถุประสงค์ข้างต้น และจะถูกเก็บรวบรวมไว้จนกว่าบริษัทฯ จะปฏิบัติตามคําร้องขอของ เจ้าของข้อมูลเสร็จสิ้น หรือจนกว่ากระบวนการโต้แย้งหรือปฏิเสธคําขอใช้สิทธิของเจ้าของข้อมูลส่วน บุคคลจะสิ้นสุด ในกรณีที่บริษัทฯ ไม่อาจปฏิบัติตามคําร้องขอของเจ้าของข้อมูลได้โดยมีเหตุผลอันสมควร ตามที่ พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคลกําหนด </p>
                                                <p>								    ผู้ยื่นคําร้องได้อ่านและเข้าใจเนื้อหาของคําร้องขอฉบับนี้อย่างละเอียดแล้ว และยืนยันว่าข้อมูลต่าง ๆ ที่ ได้แจ้งให้แก่บริษัทฯ ทราบนั้นเป็นความจริง ถูกต้อง ผู้ยื่นคําร้องเข้าใจดีว่าการตรวจสอบเพื่อยืนยัน อํานาจและตัวตนของผู้ยื่นคําร้องและเจ้าของข้อมูลนั้นเป็นการจําเป็นอย่างยิ่งเพื่อพิจารณาดําเนินการ ตามคําร้องขอของผู้ยื่นคําร้อง หากผู้ยื่นคําร้องให้ข้อมูลที่ผิดพลาดด้วยเจตนาทุจริต บริษัทฯ อาจ พิจารณาดําเนินคดีตามกฎหมายกับผู้ยื่นคําร้อง และบริษัทฯ อาจขอข้อมูลเพิ่มเติมจากผู้ยื่นคําร้องเพื่อ การตรวจสอบดังกล่าว เพื่อให้การดําเนินการตามสิทธิของเจ้าของข้อมูลเป็นไปได้อย่างถูกต้องครบถ้วน ต่อไป</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6 mb-3 text-start">
                                                <Link to="/userprofile" className="btn btn-outline-green rounded-pill px-4">ยกเลิก</Link>
                                            </div>
                                            <div className="col-6 mb-3 text-end">
                                                <button type="submit" className="btn btn-outline-green rounded-pill px-4" disabled={submitting}>
                                                    ลบบัญชี
                                                </button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            {submitstatus}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
            )}

            <ThNavFooter />
      </>
    );
  }
}
